export const taxAgentText =
  'За исключением инспекций ФНС России, на которые возложены специализированные' +
  ' функции единых регистрационных центров, инспекций ФНС России по централизованной обработке данных, инспекций' +
  ' ФНС России по работе с крупнейшими налогоплательщиками и инспекций ФНС России по федеральным округам';
